import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Validates and sanitizes a redirect URL to prevent open redirect and XSS attacks.
 * Only allows same-origin targets, given either as a path (/console/marketplace) or as
 * an absolute URL. Everything is resolved against our own origin and then re-checked,
 * which is what rejects external hosts, protocol-relative (//evil.com) and
 * backslash-normalised (/\evil.com) authorities, and javascript:/data: (origin "null").
 */
export function getSafeRedirect(redirect: string | null | undefined): string | null {
  if (!redirect || typeof redirect !== "string") return null
  const trimmed = redirect.trim()
  if (!trimmed) return null

  try {
    const url = new URL(trimmed, window.location.origin)
    if (url.origin !== window.location.origin) return null
    return url.pathname + url.search + url.hash
  } catch {
    return null
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}